import { VelocityFeedAuditTabs } from './tabs';

export function VelocityFeedAudit() {
	return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">PIPS To Velocity Feed Audit</h1>
			</div>
			<VelocityFeedAuditTabs />
		</>
	);
}
